import { MagicIcon, PreloaderIcon } from '../../../../../common/ui/icons';
import { recommendEasyTasksGroqAi } from '../../../data/planner-data-service';
import { showToast } from '../../../../../common/domain/toast-provider';
import { useState } from 'react';
import Popup from '../../../../../common/ui/popup';

export interface IRecommendEasyTodosButtonData {
    todo_title: string;
    reason: string;
}

const RecommendEasyTodosButton = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<IRecommendEasyTodosButtonData[]>([]);

    const onClick = async () => {

        setIsLoading(true);

        const response = await recommendEasyTasksGroqAi();

        setIsLoading(false);

        if(!response) {
            showToast('An error has occurred.');
            return;
        }

        setData(response);
    };

    const onPopupClose = () => {
        setData([]);
    };

    return (
        <>
            <div className="flex bg-indigo-100 rounded justify-center items-center text-xs pr-4 pl-2 py-1">
                { isLoading && <PreloaderIcon size={ 20 } color={ '#717985' }/> }

                {
                    !isLoading &&
                    <button
                        className="flex justify-center items-center whitespace-nowrap"
                        onClick={ onClick }
                        type="button">
                        <MagicIcon size={ 20 }/>
                        <span className="ml-2">Easy Tasks</span>
                    </button>
                }
            </div>

            {
                !isLoading && data?.length > 0 &&
                <Popup onClose={ onPopupClose } width={ 650 } height={ 350 }>
                    <div className="p-4 flex flex-col overflow-auto text-gray-900">

                        <div className="p-4">
                            {
                                data.map((item, i) => {
                                    return (
                                        <div className="mb-4" key={ i }>
                                            <div className="font-bold">{ item.todo_title }</div>
                                            <div>{ item.reason }</div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>
                </Popup>
            }
        </>
    )
};

export default RecommendEasyTodosButton;